export const STRING_FOR_NULL_DATA_TO_DISPLAY = 'N/A';
